import { useSettingProductTileIterationInTreatment } from "@faire/retailer-visitor-shared/settings/useSettingProductTileIteration";
import { Column } from "@faire/web/slate/Layout/Column";
import { Spacer } from "@faire/web/slate/spacing";

import { Caseline } from "../../../ComposableProductTile/__internal__/__internal__/components/CaseSizeText/Caseline";
import { CaselineProps } from "../../../ComposableProductTile/__internal__/__internal__/components/CaseSizeText/CaselineProps";
import { ExpectedShipDate } from "../../../ComposableProductTile/__internal__/__internal__/components/ProductInfo/ExpectedShipDate";
import { OrderedCount } from "../../../ComposableProductTile/__internal__/__internal__/components/ProductInfo/OrderedCount";

import { ProductLink } from "./ProductLink";

export const ProductTileProductInformation: React.FC<{
  caseLineProps?: CaselineProps;
  expectedShipDateProps?: string;
  orderCountMessage?: string;
}> = ({ caseLineProps, expectedShipDateProps, orderCountMessage }) => {
  const showTileIterationChanges = useSettingProductTileIterationInTreatment();
  return (
    <>
      {showTileIterationChanges ? <Spacer height={4} /> : null}
      <ProductLink dataTestId="product-tile-product-information">
        <Column gap={showTileIterationChanges ? 2 : 0}>
          {caseLineProps ? <Caseline {...caseLineProps} /> : null}
          {expectedShipDateProps ? (
            <ExpectedShipDate shipDate={expectedShipDateProps} />
          ) : null}
          <OrderedCount orderedCountMessage={orderCountMessage} />
        </Column>
      </ProductLink>
    </>
  );
};
